export class HeadersHandler {
    getCustomId (column, idName) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["customId"] = {
            type: "fixed",
            autofitColumns: true,
            data: [{
                value: idName,
                column: column
            }]
        };
        output.count++;
        return output;
    }

    getStatus (column) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["status"] = {
            type: "fixed",
            autofitColumns: true,
            data: [{
                value: "Status",
                column: column
            }]
        };
        output.count++;
        return output;
    }

    getDiffbotUri (column) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["diffbotUri"] = {
            type: "normal",
            autofitColumns: true,
            data: [{
                value: "Diffbot URL",
                column: column
            }]
        };
        output.count++;
        return output;
    }

    getPageUrl (column) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["pageUrl"] = {
            type: "normal",
            autofitColumns: true,
            data: [{
                value: "Page URL",
                column: column
            }]
        };
        output.count++;
        return output;
    }

    getTitle (column) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["title"] = {
            type: "normal",
            autofitColumns: true,
            data: [{
                value: "Title",
                column: column
            }]
        };
        output.count++;
        return output;
    }

    getName (column) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["name"] = {
            type: "normal",
            autofitColumns: true,
            data: [{
                value: "Name",
                column: column
            }]
        };
        output.count++;
        return output;
    }

    getDescription (column) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["description"] = {
            type: "normal",
            autofitColumns: false,
            data: [{
                value: "Description",
                column: column
            }]
        };
        output.count++;
        return output;
    }

    getSocial (column) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["linkedInUri"] = {
            type: "normal",
            autofitColumns: true,
            data: [{
                value: "LinkedIn URL",
                column: column
            }]
        };
        output.count++;
        column++;
        output.headers["twitterUri"] = {
            type: "normal",
            autofitColumns: true,
            data: [{
                value: "Twitter URL",
                column: column
            }]
        };
        output.count++;
        column++;
        output.headers["githubUri"] = {
            type: "normal",
            autofitColumns: true,
            data: [{
                value: "Github URL",
                column: column
            }]
        };
        output.count++;
        column++;
        output.headers["facebookUri"] = {
            type: "normal",
            autofitColumns: true,
            data: [{
                value: "Facebook URL",
                column: column
            }]
        };
        output.count++;
        column++;
        output.headers["angellistUri"] = {
            type: "normal",
            autofitColumns: true,
            data: [{
                value: "AngelList URL",
                column: column
            }]
        };
        output.count++;
        column++;
        output.headers["quoraTopicId"] = {
            type: "special",
            autofitColumns: true,
            data: [{
                value: "Quora Topic ID",
                column: column
            }]
        };
        column++;
        output.count++;
        return output;
    }

    getLocation (column) {
        const output = {
            headers: {},
            count: 0
        };
        output.headers["location"] = {
            data: [],
            type: "special",
            autofitColumns: true
        };
        output.headers["location"].data.push({
            value: "Country",
            column: column
        });
        output.count++;
        column++;
        output.headers["location"].data.push({
            value: "Region",
            column: column
        });
        output.count++;
        column++;
        output.headers["location"].data.push({
            value: "City",
            column: column
        });
        output.count++;
        column++;
        output.headers["location"].data.push({
            value: "Postal Code",
            column: column
        });
        output.count++;
        column++;
        output.headers["location"].data.push({
            value: "Street",
            column: column
        });
        output.count++;
        column++;
        output.headers["location"].data.push({
            value: "Address",
            column: column
        });
        output.count++;
        column++;
        return output;
    }


}